import { createAction, ActionsUnion } from "../definitions";
import { TVehicle, VehicleHistoryActionTypes } from "./types";

export interface VehicleHistoryPayload {
    currentVehicle?: TVehicle;
    previousVehicle?: TVehicle;
}

export const vehicleHistoryActions = {
    setCurrentVehicle: (payload: VehicleHistoryPayload) => createAction(VehicleHistoryActionTypes.SET_CURRENTVEHICLE, payload),
    setPreviousVehicle: (payload: VehicleHistoryPayload) => createAction(VehicleHistoryActionTypes.SET_PREVIOUSVEHICLE, payload),
    clearCurrentVehicle: () => createAction(VehicleHistoryActionTypes.CLEAR_CURRENTVEHICLE),
    clearPreviousVehicle: () => createAction(VehicleHistoryActionTypes.CLEAR_PREVIOUSVEHICLE)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type VehicleHistoryActions = ActionsUnion<typeof vehicleHistoryActions>;